module.exports = __webpack_public_path__ + "images/emoji/boot.2e55b67a7c2ee1df994e.png";